export interface TopUpBundle {
  id: string;
  price_cents: number;
  points: number;
  bonus_pct: number;
}

export const TOP_UP_BUNDLES: readonly TopUpBundle[] = [
  { id: 'starter',  price_cents: 499,  points: 525,   bonus_pct: 5 },
  { id: 'popular',  price_cents: 999,  points: 1100,  bonus_pct: 10 },
  { id: 'value',    price_cents: 2499, points: 2875,  bonus_pct: 15 },
  { id: 'large',    price_cents: 4999, points: 6000,  bonus_pct: 20 },
  { id: 'ultimate', price_cents: 9999, points: 13000, bonus_pct: 30 },
] as const;

export function getBundle(id: string): TopUpBundle | null {
  return TOP_UP_BUNDLES.find((b) => b.id === id) ?? null;
}

export function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}
